var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueBgBxC3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 131,
    viewBox: "0 0 203 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.852 57.4359C155.663 56.7223 154.235 56.643 152.967 57.3566L120.931 74.8019C119.741 75.4363 118.948 76.7051 118.948 78.1324C118.948 79.4805 119.583 80.8285 120.772 81.5422L132.825 88.9168C119.662 106.283 97.1415 110.089 75.3349 113.737C70.4978 114.53 65.5021 115.402 60.8235 116.354C34.5763 121.746 16.7345 132.609 4.83995 150.53C3.65049 152.275 4.12628 154.733 5.9501 155.843C6.58448 156.319 7.37745 156.478 8.09112 156.478C9.35987 156.478 10.5493 155.843 11.3423 154.733C22.0474 138.636 38.3032 128.803 62.4888 123.807C67.088 122.856 71.7665 122.063 76.6829 121.27C99.0446 117.543 124.42 113.261 139.407 93.0402C139.407 93.0402 139.407 92.9609 139.486 92.9609L151.936 100.573C152.57 100.97 153.284 101.129 153.918 101.129C154.552 101.129 155.187 100.97 155.742 100.653C156.931 100.018 157.724 98.7496 157.724 97.3223L158.597 60.8457C158.755 59.4183 158.042 58.1496 156.852 57.4359ZM150.27 90.4234L130.525 78.3703L150.826 67.2687L150.27 90.4234Z",
    fill: "url(#paint0_linear_4039_41382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1532 72.7407C46.8669 72.7407 47.5806 72.5821 48.2149 72.1063L56.0653 67.1106L61.061 74.961C61.7747 76.1505 63.0435 76.7849 64.3122 76.7849C65.0259 76.7849 65.7395 76.6263 66.3739 76.1505C68.1978 75.0403 68.6735 72.6614 67.5634 70.8376L62.5677 62.9872L70.4181 57.9915C72.2419 56.8813 72.7177 54.5024 71.6075 52.6786C70.4974 50.8548 68.1185 50.379 66.2946 51.4892L58.4442 56.4849L53.4485 48.6345C52.3384 46.8106 49.9595 46.3349 48.1356 47.445C46.3118 48.5552 45.836 50.9341 46.9462 52.7579L51.9419 60.6083L44.0915 65.604C42.2677 66.7142 41.7919 69.0931 42.902 70.9169C43.6157 72.1856 44.8845 72.7407 46.1532 72.7407Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.246 15.2486C196.898 13.5834 194.519 13.2662 192.854 14.6142L163.355 38.0068L152.729 24.7642C151.381 23.099 149.002 22.8611 147.337 24.2092C145.672 25.5572 145.434 27.9361 146.782 29.6014L159.787 45.8572C160.58 46.8088 161.69 47.2846 162.8 47.2846C163.672 47.2846 164.465 47.0467 165.179 46.4123L197.691 20.6408C199.277 19.2928 199.594 16.9139 198.246 15.2486Z",
    fill: "url(#paint1_linear_4039_41382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4039_41382",
    x1: 81.403,
    y1: 56.8594,
    x2: 81.403,
    y2: 156.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C023D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4039_41382",
    x1: 172.501,
    y1: 13.7734,
    x2: 172.501,
    y2: 47.2846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C023D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190825"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueBgBxC3);
export default __webpack_public_path__ + "static/media/value_bg_bx_c3.b0214317a9e323dd195a54fc91b43c1c.svg";
export { ForwardRef as ReactComponent };